import { render, staticRenderFns } from "./ScreeningSearchResultDetailSearchPhrase.vue?vue&type=template&id=02db70e2&"
import script from "./ScreeningSearchResultDetailSearchPhrase.vue?vue&type=script&lang=js&"
export * from "./ScreeningSearchResultDetailSearchPhrase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VListItemSubtitle,VListItemTitle,VRow})
